import { FhirBundleSdk } from "@metriport/fhir-sdk";
import type { CareGap } from "../../../../api/care-gaps";
import type { Suspect } from "../../../../api/suspects";
import { metadata as allergyMetadata } from "../tables/allergy";
import { metadata as carePlanMetadata } from "../tables/care-plan";
import { metadata as careTeamMetadata } from "../tables/care-team";
import { metadata as conditionMetadata } from "../tables/condition";
import { metadata as coverageMetadata } from "../tables/coverage";
import { metadata as encounterMetadata } from "../tables/encounter";
import { metadata as familyHistoryMetadata } from "../tables/family-history";
import { metadata as immunizationMetadata } from "../tables/immunization";
import { metadata as labMetadata, labPanelMetadata } from "../tables/lab";
import { metadata as medicationMetadata } from "../tables/medication";
import { diagnosticReportMetadata, imagingReportMetadata } from "../tables/notes";
import { metadata as procedureMetadata } from "../tables/procedure";
import { metadata as rawDocumentsMetadata } from "../tables/raw-documents";
import { metadata as relatedPersonMetadata } from "../tables/related-person";
import { metadata as socialHistoryMetadata } from "../tables/social-history";
import { metadata as surveyMetadata } from "../tables/survey";
import { metadata as vitalMetadata } from "../tables/vital";

export type TableRow = {
  id: string;
  originalData?: unknown;
  [key: string]: unknown;
};

export type TableMetadata = {
  tableType: string;
  displayName: string;
  getRows: (bundle: FhirBundleSdk, suspects?: Suspect[], careGaps?: CareGap[]) => TableRow[];
  /** Optional custom function to build searchable text for FlexSearch indexing */
  getSearchableText?: (row: Record<string, unknown>) => string;
};

/**
 * Browse mode table metadata.
 * Lab Panels are NOT included here - they are handled via toggle in LabTable.
 * Used when the user is browsing without a search query.
 */
export const BROWSE_TABLE_METADATA: TableMetadata[] = [
  diagnosticReportMetadata,
  imagingReportMetadata,
  conditionMetadata,
  medicationMetadata,
  allergyMetadata,
  procedureMetadata,
  labMetadata,
  vitalMetadata,
  surveyMetadata,
  socialHistoryMetadata,
  immunizationMetadata,
  carePlanMetadata,
  familyHistoryMetadata,
  relatedPersonMetadata,
  coverageMetadata,
  encounterMetadata,
  careTeamMetadata,
  rawDocumentsMetadata,
];

/**
 * Search mode table metadata.
 * Both Labs (individual) and Lab Panels are separate searchable sections.
 * Used when the user has an active search query.
 */
export const SEARCH_TABLE_METADATA: TableMetadata[] = [
  diagnosticReportMetadata,
  imagingReportMetadata,
  conditionMetadata,
  medicationMetadata,
  allergyMetadata,
  procedureMetadata,
  labMetadata,
  labPanelMetadata,
  vitalMetadata,
  surveyMetadata,
  socialHistoryMetadata,
  immunizationMetadata,
  carePlanMetadata,
  familyHistoryMetadata,
  relatedPersonMetadata,
  coverageMetadata,
  encounterMetadata,
  careTeamMetadata,
  rawDocumentsMetadata,
];
